import { useState } from "react";

const useReportManager = () => {
  const [isNewReportModalOpen, setIsNewReportModalOpen] = useState(false);
  const [isFullScreenReportModalOpen, setIsFullScreenReportModalOpen] = useState(false);
  const [selectedFund, setSelectedFund] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState(null);

  const openNewReportModal = () => setIsNewReportModalOpen(true);
  const closeNewReportModal = () => setIsNewReportModalOpen(false);

  const openFullScreenReportModal = (fund, reportType) => {
    setSelectedFund(fund);
    setSelectedReportType(reportType);
    setIsFullScreenReportModalOpen(true);
  };
  const closeFullScreenReportModal = () => setIsFullScreenReportModalOpen(false);

  return {
    isNewReportModalOpen,
    openNewReportModal,
    closeNewReportModal,
    isFullScreenReportModalOpen,
    openFullScreenReportModal,
    closeFullScreenReportModal,
    selectedFund,
    selectedReportType,
  };
};

export default useReportManager;
